import React from "react";
import { Box, Typography, Paper, Avatar } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // For bullet points

const InstructorDetails = () => {
    return (
        <Paper
            sx={{
                mt: 1,
                padding: "25px",
                textAlign: "center",
                borderRadius: "12px",
                background: "#ffffff",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                mx: "auto",
                mb:3
            }}
        >
            {/* Instructor Avatar */}
            <Avatar
                src="/instructor.jpg"
                sx={{
                    width: 90,
                    height: 90,
                    margin: "0 auto",
                    border: "4px solid #e0e0e0",
                }}
            />

            {/* Instructor Name & Verification */}
            <Typography variant="h6" fontWeight="bold" sx={{ mt: 2, color: "#222" }}>
                Mr. Abhiram{" "}
                <VerifiedIcon sx={{ color: "#28a745", fontSize: "20px" }} />
            </Typography>

            <Typography variant="body2" color="gray" sx={{ mb: 2 }}>
                Certified Google Cloud Professional
            </Typography>

            {/* Benefits Card */}
            <Box
                sx={{
                    mt: 2,
                    background: "#f8f9fa",
                    padding: "15px",
                    borderRadius: "10px",
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                    textAlign: "left",
                }}
            >
                <Typography variant="body1" fontWeight="bold" sx={{ mb: 1 }}>
                    Upon completing this training:
                </Typography>

                <Box component="ul" sx={{ listStyle: "none", padding: "0", margin: "0" }}>
                    {[
                        "Become Google Cloud Certified",
                        "Hands-on Labs & Real-World Projects",
                        "24/7 Mentorship Support",
                    ].map((item, index) => (
                        <Box component="li" key={index} sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                            <CheckCircleIcon sx={{ color: "#28a745", fontSize: "18px", mr: 1 }} />
                            <Typography variant="body2" sx={{ color: "#444" }}>
                                {item}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Paper>
    );
};

export default InstructorDetails;
